export default function isDevelopment() {
	// eslint-disable-next-line
	return (process.env.NODE_ENV === 'development')
}
